import Vue from 'vue';
import Vuex from 'vuex';
import videos from '../videos';

// console.log(videos);

Vue.use(Vuex);

// export type State = {
//     isLoading: Boolean,
//     popup: Object,
//     currentPage: String,
//     quizzes: Array,
//     ending: String,
//     answers: Array,
//     resultArray: Array,
//     result: String,
// }

const defaultState = {
    // 網站是否正在載入中
    isLoading: true,
    // Popup Object
    popup: null,
    // 目前所在頁面，共有三頁 Home, Quiz, Analysis
    currentPage: 'Home',
    // 播放器
    player: null,
    // intro 影片 id
    // intro: '6w8fKHQnuXc',
    // intro 影片是否播放過
    // isIntroPlayed: false,
    // target 影片 id
    target: {
        change:     videos['target']['change'],   // 轉職者
        freshman:   videos['target']['freshman'], // 新鮮人
        digital:    videos['target']['digital'],  // 數位人
    },
    // target 影片是否播放過
    isTargetPlayed: false,
    // target 字串
    targetString: '',
    // 測驗題目及選項
    quizzes: [
        {
            video: {
                main: {desktop: videos['q1Main'], mobile: videos['q1Main'], counter: 19250},
                idle: {desktop: videos['q1Idle'], mobile: videos['q1Idle']},
            },
            question: '首先我需要了解您的薪資\n從明年起基本月薪將調高到新台幣兩萬六千四百元\n相較去年暴漲了一千一百五十塊，相信全體國民實現財富自由指日可待\n您也領著如此豐厚的月薪嗎？',
            options: [
                { text: '高薪階層:\n兩萬六以上', score: 'A', name: 'q1-a', video: videos['q1A'], id: 'salary_none' },
                { text: '土豪暴發戶:\n五萬以上', score: 'B', name: 'q1-b', video: videos['q1B'], id: 'salary_limit' },
                { text: '窮得只剩下錢:\n十萬以上', score: 'C', name: 'q1-c', video: videos['q1C'], id: 'salary_good' },
            ]
        },
        {
            video: {
                main: {desktop: videos['q2Main'], mobile: videos['q2Main'], counter: 18120},
                idle: {desktop: videos['q2Idle'], mobile: videos['q2Idle']},
            },
            question: '優秀的企業文化一定都有老鳥帶菜鳥\n想必您的主管也花了許多心思栽培您幫大家買咖啡的技能\n除此之外，貴公司還有什麼其它的培育計畫或訓練課程嗎？',
            options: [
                { text: '放置Play', score: 'A', name: 'q2-a', video: videos['q2A'], id: 'training_none' },
                { text: '培訓有限', score: 'B', name: 'q2-b', video: videos['q2B'], id: 'training_limit' },
                { text: '資源充沛', score: 'C', name: 'q2-c', video: videos['q2C'], id: 'training_good' },
            ]
        },
        {
            video: {
                main: {desktop: videos['q3Main'], mobile: videos['q3Main'], counter: 18060},
                idle: {desktop: videos['q3Idle'], mobile: videos['q3Idle']},
            },
            question: '有科技工具的輔助能讓業務人才的工作更有效率\n就像人人瘋搶的水果手機，也是因為有高尖端的科技\n怎麼可能只是因為它看起來比較潮？膚淺！\n請問您的公司也是如此重視科技輔助、聰明作業嗎？',
            options: [
                { text: '公司連\nWi-Fi都會斷', score: 'A', name: 'q3-a', video: videos['q3A'], id: 'tech_none' },
                { text: '至少有轉接頭', score: 'B', name: 'q3-b', video: videos['q3B'], id: 'tech_limit' },
                { text: '連打掃阿姨\n都懂AI', score: 'C', name: 'q3-c', video: videos['q3C'], id: 'tech_good' },
            ]
        },
        {
            video: {
                main: {desktop: videos['q4Main'], mobile: videos['q4Main'], counter: 19000},
                idle: {desktop: videos['q4Idle'], mobile: videos['q4Idle']},
            },
            question: '最後想請問您，公司的規模大小直接影響了內部資源的交流\n那麼貴公司除了\n辦公室戀情搞小團體散播八卦嘲笑老闆背後說同事壞話以外(快速唸過)\n其它資源、資訊的分享狀況怎麼樣呢？',
            options: [
                { text: '奈米公司:\n孤軍奮戰', score: 'A', name: 'q4-a', video: videos['q4A'], id: 'group_none' },
                { text: '中型組織:\n資訊短缺', score: 'B', name: 'q4-b', video: videos['q4B'], id: 'group_limit' },
                { text: '大型企業:\n互助共享', score: 'C', name: 'q4-c', video: videos['q4C'], id: 'group_good' },
            ]
        },
    ],
    // 結果影片
    resultVideo: {
        'q1-a': videos['result']['q1A'], // 景觀型格局
        'q1-b': videos['result']['q1B'], // 挑高型格局
        'q1-c': videos['result']['q1C'], // 開放型格局
        'q2-a': videos['result']['q2A'], // 親子房型格局
        'q2-b': videos['result']['q2B'], // 透天厝型格局
        'q2-c': videos['result']['q2C'], // 開放型格局
        'q3-a': videos['result']['q3A'], // 採光型格局
        'q3-b': videos['result']['q3B'], // 通風型格局
        'q3-c': videos['result']['q3C'], // 開放型格局
        'q4-a': videos['result']['q4A'], // 樓中樓型格局
        'q4-b': videos['result']['q4B'], // 附車位型格局
        'q4-c': videos['result']['q4C'], // 開放型格局
    },
    // 結尾影片
    ending: videos['ending'],
    // 結尾影片是否播放完
    isEndingPlayed: false,
    // 作答陣列
    answers: [],
    // 抽取結果的整體機制
    resultArray: [],
    // 最終結果
    result: '',
    // audio player
    // audioPlayer: null,
    // iOS Version
    iosVersion: null,
}

const mutations = {
    setLoading(state, value) {
        state.isLoading = value;
    },
    setPage(state, value) {
        state.currentPage = value;
    },
    setPopup(state, value) {
        state.popup = value;
    },
    closePopup(state) {
        state.popup = null;
    },
    setPlayer(state, value) {
        state.player = value;
    },
    // setAudioPlayer(state, value) {
    //     state.audioPlayer = value;
    // },
    setIntroPlayed(state, value) {
        state.isIntroPlayed = value;
    },
    setTargetPlayed(state, value) {
        state.isTargetPlayed = value;
    },
    setTargetString(state, value) {
        state.targetString = value;
    },
    updateAnswer(state, value) {
        state.answers.push(value);
    },
    updateResultArray(state, value) {
        state.resultArray = value;
    },
    setResult(state, value) {
        state.result = value;
    },
    resetQuizzes(state) {
        state.answers = [];
        state.result = '';
        state.resultArray = [];
        // state.isIntroPlayed = false;
        state.isTargetPlayed = false;
    },
    setIosVersion(state, value) {
        state.iosVersion = value;
    },
}

const getters = {};
const actions = {};
const modules = {};

export default new Vuex.Store({
    state: defaultState,
    getters: getters,
    mutations: mutations,
    actions: actions,
    modules: modules
});